<template>
    <div class="component-logos-with-text">
        <ThLink
            v-for="(item, index) in data.logos"
            :key="index"
            v-bind="createCmsLink(item.logoLink, cmsLinkPrerequisites)"
            class="logo-item"
        >
            <CmsImage
                :data="item.image"
                class="image"
                :sizes="['100vw', [320, '240px']]"
            />

            <ThTitle
                class="title"
                tag="H4"
                alignment="CENTER"
                title-style="SECONDARY"
            >
                {{ item.title }}
            </ThTitle>

            <div
                v-if="item.description"
                class="description"
            >
                {{ item.description }}
            </div>
        </ThLink>
    </div>
</template>

<script setup lang="ts">
import type { ComponentLogosWithTextFragment } from '@/graphql/api'
import { useCmsLinkPrerequisites, createCmsLink } from '..'

import ThLink from '@/components/ui/buttons/ThLink.vue'
import CmsImage from '../CmsImage.vue'
import ThTitle from '@/components/ui/title/ThTitle.vue'

const { data } = defineProps<{
    data: ComponentLogosWithTextFragment
}>()

const cmsLinkPrerequisites = useCmsLinkPrerequisites()
</script>

<style lang="scss" scoped>
.component-logos-with-text {
    --gap: 36px;

    margin: 0 auto;
    width: 100%;
    max-width: 1320px;
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    gap: var(--gap);
    padding: 0 calc(var(--gap) / 2);

    @include min-width(640) {
        grid-template-columns: 1fr 1fr;
    }

    @include min-width(768) {
        grid-template-columns: 1fr 1fr 1fr;
        --gap: 48px;
    }

    .logo-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        text-align: center;

        .image {
            width: 100%;
            max-width: 240px;
            height: auto;
            margin: 0 auto 16px;
        }

        .description {
            font-family: $sectra-font-stack;
            font-style: italic;
            font-weight: 400;
            font-size: 1.3rem;
            color: $grey-500;
        }
    }
}
</style>
